import apiClient from "../../../../../../services/apiClient";

export const getAttendanceData = async (idKg, idGr, date, period) => {
  const linkPost = `tabel_group/perchild/${idKg}/${idGr}`;
  
  // Убеждаемся, что date - это Date объект или строка ISO
  const dateToSend = typeof date === 'string' ? date : date.toISOString();
  const body = { date: dateToSend, period };
  
  try {
    const response = await apiClient.post(linkPost, body);
    return response;
  } catch (error) {
    throw new Error(`Error getting attendance data: ${error}`);
  }
};

export const getChildrenInfo = async (idKg, idGroup, dateTo, period) => {
  const linkPost = `kindergartens/${idKg}/children/main_info?groups=${idGroup}&date_to=${dateTo}&period=${period}`;
  
  try {
    const response = await apiClient.get(linkPost);
    return response;
  } catch (error) {
    throw new Error(`Error getting children info: ${error}`);
  }
};

export const saveAttendance = async (attendanceData) => {
  const { idKg, idGr, date, ...rest } = attendanceData;
  
  // Убеждаемся, что date - это строка ISO с временем 12:00:00
  let dateToSend;
  if (typeof date === 'string') {
    dateToSend = date;
  } else if (date instanceof Date) {
    dateToSend = date.toISOString();
  } else {
    // Если date - это что-то другое, пробуем создать Date
    dateToSend = new Date(date).toISOString();
  }
  
  const payload = {
    ...rest,
    idKg,
    idGr,
    date: dateToSend
  };
  
  const linkPost = `tabel_group/${idKg}/${idGr}`;
  
  try {
    const response = await apiClient.post(linkPost, payload);
    return response;
  } catch (error) {
    throw new Error(`Error saving attendance: ${error.message}`);
  }
};

export const saveTempAttendance = async (attendanceData) => {
  const { idKg, idGr, date, ...rest } = attendanceData;
  
  // Убеждаемся, что date - это строка ISO с временем 12:00:00
  let dateToSend;
  if (typeof date === 'string') {
    dateToSend = date;
  } else if (date instanceof Date) {
    dateToSend = date.toISOString();
  } else {
    dateToSend = new Date(date).toISOString();
  }
  
  const payload = {
    ...rest,
    idKg,
    idGr,
    date: dateToSend
  };
  
  const linkPost = `tabel_group_temp/${idKg}/${idGr}`;
  
  try {
    const response = await apiClient.post(linkPost, payload);
    return response;
  } catch (error) {
    throw new Error(`Error saving temporary attendance: ${error.message}`);
  }
};